import LoadingButton from '@mui/lab/LoadingButton';
import { alpha, darken, styled } from '@mui/material';
export var Component = styled(LoadingButton)(function (_a) {
    var theme = _a.theme;
    return ({
        borderRadius: '5px',
        textTransform: 'none',
        fontWeight: 600,
        letterSpacing: '0px',
        '&.MuiButtonRoot': {
            '&:disabled': {
                color: theme.palette.action.disabled,
                backgroundColor: theme.palette.action.disabledBackground,
                borderColor: theme.palette.action.disabledBackground,
            },
        },
        '&.MuiButton-sizeSmall': {
            height: '34px',
            padding: '6px 10px',
            fontSize: '0.8125rem',
            lineHeight: '1.375rem',
        },
        '&.MuiButton-sizeMedium': {
            height: '40px',
            padding: '8px 16px',
            fontSize: '0.875rem',
            lineHeight: '1.5rem',
        },
        '&.MuiButton-sizeLarge': {
            height: '50px',
            padding: '12px 22px',
            fontSize: '0.9375rem',
            lineHeight: '1.625rem',
        },
        '&.MuiButton-contained': {
            boxShadow: 2,
            '&:hover': {
                boxShadow: 4,
            },
        },
        '&.MuiButton-containedPrimary': {
            '&:hover': {
                backgroundColor: darken(theme.palette.primary.main, 0.1),
            },
        },
        '&.MuiButton-containedSecondary': {
            backgroundColor: '#F5F5F5',
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: '#EEEEEE',
            },
            '&:disabled': {
                color: theme.palette.action.disabled,
                backgroundColor: theme.palette.action.disabledBackground,
            },
        },
        '&.MuiButton-containedWhite': {
            backgroundColor: '#FFFFFF',
        },
        '&.MuiButton-outlined': {
            '&:disabled': {
                border: '1px solid rgba(0, 0, 0, 0.12)',
            },
        },
        '&.MuiButton-outlinedPrimary': {
            border: "1px solid ".concat(alpha(theme.palette.primary.main, 0.75)),
            '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
            },
        },
        '&.MuiButton-outlinedSecondary': {
            border: '1px solid rgba(51, 55, 69, 0.15)',
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
                color: theme.palette.text.primary,
            },
        },
        '&.MuiButton-outlinedBlack': {
            backgroundColor: theme.palette.black.main,
            color: theme.palette.black.contrastText,
            '&:disabled': {
                color: theme.palette.action.disabled,
                backgroundColor: 'transparent',
                borderColor: theme.palette.action.disabledBackground,
            },
        },
        '&.MuiButton-outlinedWhite': {
            color: '#000000',
            '&:disabled': {
                color: theme.palette.action.disabled,
            },
        },
        '&.MuiButton-textPrimary': {
            '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
            },
        },
        '&.MuiButton-textSecondary': {
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
                color: theme.palette.text.primary,
            },
        },
        '&.MuiButton-textBlack': {
            backgroundColor: theme.palette.black.main,
            color: theme.palette.black.contrastText,
            '&:disabled': {
                color: theme.palette.action.disabled,
                backgroundColor: 'transparent',
            },
        },
        '&.MuiButton-textWhite': {
            color: '#000000',
            '&:disabled': {
                color: theme.palette.action.disabled,
            },
        },
        '.MuiButton-startIcon': {
            '.MuiSvgIcon-fontSizeSmall': {
                fontSize: '18px',
            },
            '.MuiSvgIcon-fontSizeMedium': {
                fontSize: '20px',
            },
            '.MuiSvgIcon-fontSizeLarge': {
                fontSize: '24px',
            },
        },
        '.MuiButton-endIcon': {
            '.MuiSvgIcon-fontSizeSmall': {
                fontSize: '18px',
            },
            '.MuiSvgIcon-fontSizeMedium': {
                fontSize: '20px',
            },
            '.MuiSvgIcon-fontSizeLarge': {
                fontSize: '24px',
            },
        },
    });
});
Component.displayName = 'Button';
